// extracted by mini-css-extract-plugin
export default {"link":"eC-z","disabled":"fC-z"};